import type { ChatQuickCommand } from '@/components/chat/ChatInput';

export const QUICK_COMMANDS: ChatQuickCommand[] = [
  {
    command: 'sales',
    label: 'Ventes du jour',
    prompt: 'Resume mes ventes du jour avec les points forts et un risque a surveiller.',
  },
  {
    command: 'stock',
    label: 'Alerte stock',
    prompt: 'Quels produits sont en rupture ou en alerte stock aujourd hui ?',
  },
  {
    command: 'customers',
    label: 'Top clients',
    prompt: 'Qui sont mes meilleurs clients cette semaine et que dois je faire pour les retenir ?',
  },
];
